/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'
import no_redux_vs_reduxImg from 'assets/images/no-redux-vs-redux.png'
import vanilla_flowImg from 'assets/images/vanilla-flow.gif'
import redux_flowImg from 'assets/images/redux-flow.gif'
import flowImg from 'assets/images/flow.png'

export const _2 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>2 - Основные принципы Redux</h2>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        <b>Предсказуемость результата</b> - существует всегда один источник правды, хранилище (
        <code className={styles.code}>store</code>), хранящее в себе состояние приложения и методы для работы с ним.
      </li>
      <li className={styles.list__item}>
        <b>Поддреживаемость</b> - есть набор правил и лучших практик о том, как должен быть структурирован код, что
        делает его более единообразным и понятным.
      </li>
      <li className={styles.list__item}>
        <b>Инструменты разработчика</b> - все происходящее можно отслеживать в режиме реального времени.
      </li>
      <li className={styles.list__item}>
        <b>Простота тестирования</b> - первое правило написания тестируемого кода - писать небольшие функции, которые
        выполняют только одну вещь и независимы. Redux - это в основном функции: маленькие, чистые и изолированные.
      </li>
    </ul>
    <img className={styles.img} src={no_redux_vs_reduxImg} alt="no-redux-vs-redux" />
    <section className={styles.subsection}>
      <h3 className={styles.h3}>2.1 - Поток данных</h3>
      <p className={styles.description}>
        Без использования библиотеки управления состоянием процесс обновления данных выглядит следующим образом:
        компонент инициализирует изменение состояния вызвав метод полученный пропом, после чего измененное состояние
        пробрасывается пропами вниз по дереву.{' '}
      </p>
      <img className={styles.img} src={vanilla_flowImg} alt="vanilla-flow" />
      <p className={styles.description}>
        Поток данных в Redux всегда однонаправленный, и очень простой. За данные отвечает хранилище, компоненты только
        вызывают методы обновления данных и потом получают обновленные данные.{' '}
      </p>
      <img className={styles.img} src={redux_flowImg} alt="redux-flow" />
      <ul className={styles.list}>
        <li className={styles.list__item}>
          Пользователь, работая с интерфейсом, инициализирует отправку действий (<code v>actions</code>)
        </li>
        <li className={styles.list__item}>
          Хранилище (<code className={styles.code}>store</code>) вызывает все объявленные редьюсеры (
          <code className={styles.code}>reducers</code>), передавая им текущее состояние (
          <code className={styles.code}>state</code>) и действие (<code className={styles.code}>action</code>)
        </li>
        <li className={styles.list__item}>
          Хранилище (<code className={styles.code}>store</code>) сохраняет обновленное дерево состояния (
          <code className={styles.code}>state</code>) возвращенное из редьюсеров (
          <code className={styles.code}>reducers</code>)
        </li>
        <li className={styles.list__item}>
          При обновлении состояния (<code className={styles.code}>state</code>) вызываются все подписчики для обновления
          интерфейса
        </li>
      </ul>
      <img className={styles.img} src={flowImg} alt="flow" />
    </section>
  </section>
))
